import IconTrashSolid from '@/assets/icons/font_awesome/trash-solid.svg?react';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { UI_PRIMITIVE__tooltip } from '@/components/ui/UI_PRIMITIVE__tooltip';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { remote_workspace_user_invitation_delete } from '@/state/workspace/user_invitation/remote_workspace_user_invitation_delete';
import { RequestWorkspaceUserInvitationDelete } from '@shared/dto/+workspace/workspace_user_invitation/_requests/request_workspace_user_invitation_delete';
import { DTOWorkspaceUserInvitation } from '@shared/dto/+workspace/workspace_user_invitation/dto_workspace_user_invitation';

interface Props {
  item: DTOWorkspaceUserInvitation;
}

export function WButtonUserInvitationDelete({ item }: Props) {
  const dispatch = use_dispatch();

  async function onClick() {
    let request = new RequestWorkspaceUserInvitationDelete();
    request.workspace_id = item.workspace_id;
    request.invitation_id = item._id;

    await dispatch(remote_workspace_user_invitation_delete([request]));
  }

  return (
    <UI_PRIMITIVE__tooltip tooltip_title={'Revoke invitation'}>
      <UI_PRIMITIVE__button_with_icon_animated
        variant={'no-border-on-component'}
        iconClassNameBase="!w-5 !h-5"
        iconClassNameHovered={` !text-red-400`}
        iconClassNameNonHovered={` !text-red-700`}
        Icon={IconTrashSolid}
        onClick={onClick}
      />
    </UI_PRIMITIVE__tooltip>
  );
}
